import React from "react";
import { intl } from "dmsbasereact";
import { Box, Typography } from "@mui/material";

/**
 * DmsHelpCenterContactTab - Displays contact information for the Lena Program
 */
export const DmsHelpCenterContactTab = () => {
  return (
    <Box sx={{ py: 2 }}>
      <Typography variant="body1" sx={{ mb: 3 }}>
        {intl.get("helpCenter.contact.description").d("In case of questions or requests, contact the Lena Program through phone")}{" "}
        <Box component="span" sx={{ fontWeight: "bold" }}>0800 703 0001</Box>{" "}
        {intl.get("helpCenter.contact.or").d("or email")}{" "}
        <Box component="span" sx={{ fontWeight: "bold" }}>programalena@eurofarma.com</Box>
      </Typography>
    </Box>
  );
};
